import { render } from "./ProveedoresVue.vue?vue&type=template&id=2a2a5227&scoped=true"
import script from "./ProveedoresVue.vue?vue&type=script&lang=js"
export * from "./ProveedoresVue.vue?vue&type=script&lang=js"

import "./ProveedoresVue.vue?vue&type=style&index=0&id=2a2a5227&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a2a5227"]])

export default __exports__